module.exports = __webpack_public_path__ + "static/img/redcat-logo.c071974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redcat-logo.svg
// module id = zdLv
// module chunks = 1